var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bi:file-earmark-image"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.81445 7.875C8.03606 7.875 8.25549 7.83135 8.46023 7.74655C8.66497 7.66174 8.851 7.53744 9.0077 7.38074C9.1644 7.22404 9.2887 7.03802 9.3735 6.83328C9.45831 6.62854 9.50195 6.40911 9.50195 6.1875C9.50195 5.96589 9.45831 5.74646 9.3735 5.54172C9.2887 5.33698 9.1644 5.15096 9.0077 4.99426C8.851 4.83756 8.66497 4.71326 8.46023 4.62845C8.25549 4.54365 8.03606 4.5 7.81445 4.5C7.3669 4.5 6.93768 4.67779 6.62121 4.99426C6.30474 5.31072 6.12695 5.73995 6.12695 6.1875C6.12695 6.63505 6.30474 7.06428 6.62121 7.38074C6.93768 7.69721 7.3669 7.875 7.81445 7.875Z",
    fill: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.25 15.75C16.25 16.3467 16.0129 16.919 15.591 17.341C15.169 17.7629 14.5967 18 14 18H5C4.40326 18 3.83097 17.7629 3.40901 17.341C2.98705 16.919 2.75 16.3467 2.75 15.75V2.25C2.75 1.65326 2.98705 1.08097 3.40901 0.65901C3.83097 0.237053 4.40326 0 5 0L11.1875 0L16.25 5.0625V15.75ZM5 1.125C4.70163 1.125 4.41548 1.24353 4.2045 1.4545C3.99353 1.66548 3.875 1.95163 3.875 2.25V13.5L6.377 10.998C6.46567 10.9095 6.58132 10.8532 6.70563 10.8379C6.82994 10.8226 6.9558 10.8493 7.06325 10.9136L9.5 12.375L11.9266 8.9775C11.9741 8.9111 12.0355 8.85582 12.1065 8.81552C12.1775 8.77522 12.2564 8.75085 12.3377 8.7441C12.4191 8.73736 12.5009 8.7484 12.5776 8.77647C12.6542 8.80453 12.7239 8.84895 12.7816 8.90662L15.125 11.25V5.0625H12.875C12.4274 5.0625 11.9982 4.88471 11.6818 4.56824C11.3653 4.25178 11.1875 3.82255 11.1875 3.375V1.125H5Z",
    fill: "#A2A2A2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewImage);
export default __webpack_public_path__ + "static/media/new_image.d2963df63d82aac5729b3a995bedcd4d.svg";
export { ForwardRef as ReactComponent };